import { useState, useEffect } from "react";
import {
  getWorkFollow,
  getPaginatedWorkFollows,
} from "../services/MachineWorkFlowServices";
import { errorStatusHandle } from "../utils/error-utils";
import {
  getUserInTemplates,
  getWorkflowPageSetting,
} from "../api/setting/pageApi";
import { useDispatch } from "react-redux";
import { setPageSettings } from "../store/actions/pageActions";
import { createGroupTree, getGroupPath, GroupNode } from "../utils/group-tree";
import {
  clearComponentLoading,
  clearPageLoading,
  setComponentLoading,
  setPageLoading,
} from "../store/actions";

const useWorkflowSettingPage = () => {
  const [templates, setTemplates] = useState([]);
  // const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [groupTree, setGroupTree] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageLoading());
    getWorkflowPageSetting("detail")
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
        let user = [];
        // get all users for select
        // pageSettings.options.users.forEach((u, i) => {
        //   const temp = {
        //     value: u.id,
        //     label: `${u.name}(${u.username})`,
        //     email: u.email,
        //   };
        //   user = [...user, temp];
        // });
        // setUsers(user);

        let template = [];
        pageSettings.options.templates.forEach((t, i) => {
          const temp = {
            value: t.id,
            label: t.name,
          };
          template = [...template, temp];
        });
        setTemplates(template);

        setDepartments(pageSettings.options.departments);
        setGroups(pageSettings.options.groups);
        setGroupsChildren(pageSettings.options.group_and_children);
        let grouplst = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        };
        Object.entries(pageSettings.options.group_list).forEach((group) => {
          grouplst[group[0]] = group[1].map((v) => {
            return { value: v.id, label: v.name };
          });
        });
        setGroupsList(grouplst);
        const root = createGroupTree(
          pageSettings.options.group_list,
          pageSettings.options.group_and_children
        );
        setGroupTree(root);
        dispatch(clearPageLoading());
      })
      .catch((e) => {
        dispatch(clearPageLoading());
        errorStatusHandle(e.response);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // users,
    departments,
    templates,
    // setUsers,
    setDepartments,
    setTemplates,
    groups,
    setGroups,
    groupsList,
    setGroupsList,
    groupsChildren,
    setGroupsChildren,
    groupTree,
  };
};

const useWorkFollowListPageSetting = (setFilters) => {
  const [templates, setTemplates] = useState([]);
  const [frequencies, setFrequencies] = useState([{ value: 0, label: "[ALL]" }]);
  const [filterList, setFilterList] = useState({ template: null });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageLoading());
    getWorkflowPageSetting("list")
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
        if (pageSettings.user_setting?.setting) {
          setFilterList(pageSettings.user_setting.setting);
          setFilters(pageSettings.user_setting.setting)
        }
        let template = [{ value: null, label: "[ALL]" }];
        pageSettings.options.templates.forEach((t, i) => {
          const temp = {
            value: t.id,
            label: t.name,
          };
          template = [...template, temp];
        });
        setTemplates(template);
        const f = [{ value: 0, label: "[ALL]" }];
        for (const frequency of pageSettings.options.frequencies) {
          f.push({ value: frequency[0], label: frequency[1] });
        }
        setFrequencies(f);
        dispatch(clearPageLoading());
      })
      .catch((e) => {
        dispatch(clearPageLoading());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { templates, frequencies, setTemplates, setFrequencies, filterList, setFilterList };
};

// get init page data
const useWorkFollowData = (workFollowId, groupTree) => {
  const [workFollowName, setWorkFollowName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [frequency, setFrequency] = useState(1);
  const [workTemplates, setWorkTemplates] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      (workFollowId !== "new" && groupTree === null) ||
      (tableData.length === 0 && workFollowId !== "new")
    ) {
      dispatch(setComponentLoading("workflow_list"));
      getWorkFollow(workFollowId)
        .then((response) => {
          setWorkFollowName(response.data.name);
          setFrequency(response.data.frequency);
          let templates = [];
          response.data.templates.forEach((template) => {
            templates.push({
              value: template.id,
              label: template.name,
            });
          });
          setWorkTemplates(templates);
          let tableRows = [];
          response.data.sequences.forEach((work) => {
            const groupNode = new GroupNode(work.group);
            const groupPath = getGroupPath(groupTree, groupNode);
            tableRows[work.workflow_order - 1] = {
              id: work.id,
              type: work.type,
              group_1: groupPath[1]?.data?.value ?? null,
              group_2: groupPath[2]?.data?.value ?? null,
              group_3: groupPath[3]?.data?.value ?? null,
              group_4: groupPath[4]?.data?.value ?? null,
              group_5: groupPath[5]?.data?.value ?? null,
              position: work.department?.position?.id ?? null,
              user_id: work.user?.id ?? null,
              email: work.user?.email ?? "",
              can_reject: work.can_reject,
              can_approve: work.can_approve,
              notification_page: work.notification_page,
              notification_email: work.notification_email,
              group: work.group,
            };
          });
          setTableData(tableRows);
          dispatch(clearComponentLoading("workflow_list"));
        })
        .catch((e) => {
          errorStatusHandle(e);
          dispatch(clearComponentLoading("workflow_list"));
        });
    } else if (groupTree !== null) {
      const tmp = tableData.map((row) => {
        const groupNode = new GroupNode(row.group);
        const groupPath = getGroupPath(groupTree, groupNode);
        return {
          id: row.id,
          type: row.type,
          group_1: groupPath[1]?.data?.value ?? null,
          group_2: groupPath[2]?.data?.value ?? null,
          group_3: groupPath[3]?.data?.value ?? null,
          group_4: groupPath[4]?.data?.value ?? null,
          group_5: groupPath[5]?.data?.value ?? null,
          position: row.position ?? null,
          user_id: row.user_id ?? null,
          email: row.email ?? "",
          can_reject: row.can_reject,
          can_approve: row.can_approve,
          notification_page: row.notification_page,
          notification_email: row.notification_email,
          group: row.group,
        };
      });
      setTableData(tmp);
    }
  }, [workFollowId, groupTree]);
  return {
    tableData,
    frequency,
    workTemplates,
    workFollowName,
    setTableData,
    setFrequency,
    setWorkTemplates,
    setWorkFollowName,
  };
};

const useWorkFollowList = (reload) => {
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10); //@todo
  const [numPages, setNumPages] = useState(1);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    workflow_name: null,
    frequency: null,
    template: null,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setComponentLoading("workflow_list"));
    getPaginatedWorkFollows(page, perPage, filters)
      .then((response) => {
        if (response.data.length) {
          response.data.map((r) => (r.delete = false));
        }
        setTableData(response.data);
        setCount(response.count);
        setNumPages(response.num_pages);
        dispatch(clearComponentLoading("workflow_list"));
      })
      .catch((e) => {
        errorStatusHandle(e);
        dispatch(clearComponentLoading("workflow_list"));
      });
  }, [page, perPage, filters, reload]);
  return {
    tableData,
    page,
    count,
    filters,
    numPages,
    perPage,
    setTableData,
    setPage,
    setCount,
    setFilters,
    setNumPages,
    setPerPage,
  };
};

const useUserSelect = (templates) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    if (templates?.length === 0) {
      return;
    }
    const template_ids = templates.map((t) => t?.value);
    getUserInTemplates(template_ids).then((response) => {
      let user = [];
      // get all users for select
      response.data.data.forEach((u, i) => {
        const temp = {
          value: u.id,
          label: `${u.name}(${u.username})`,
          email: u.email,
        };
        user = [...user, temp];
      });
      setUsers(user);
    });
  }, [templates]);
  return { users, setUsers };
};



export {
  useWorkflowSettingPage,
  useWorkFollowData,
  useWorkFollowList,
  useWorkFollowListPageSetting,
  useUserSelect
};
